<template>
  <div class="pages_su_one">
    <div class="pages_ab">
      <div class="pages_title fx fa_c"> 
          <div class="fs_06 fw_6 pr01">公司简介</div>
          <div class=" fs_03 ls2">COMPANY OVERVIEW</div>
      </div>
      <div class="ab_content">
        <img src="@/assets/summany/fazhan/fz_top.png" class="content_img">
        <div class="cfour ml_4">
            <!-- <Text/> -->
            <div id="time-line">
                <div class="item" v-for="item in timelineList" :key="item.index">
                    <div class="kxy">
                        <div class="yx"></div>
                    </div>
                    <div class="item-index   animate__fadeInLeft">{{ item.index }}</div>
                    <div class="item-content fx  animate__fadeInRight">
                    <div><span class="fw_8 color3 pr01">·</span></div>
                    <div class="lh044">{{ item.content }}</div> 
                    </div>
                </div>
            </div>
        </div>
      </div>

    </div>
   
  </div>
</template>
<script  setup>
import { ref, nextTick, onMounted } from 'vue'
onMounted(() => {

});
// 城市板块动画
// const handleScroll =(e) => {
//   let currentScroll = window.pageYOffset; //表示当前滚动的位置
//   let viewHeight = window.innerHeight;//视口高度
//   if (currentScroll > viewHeight) {
//     testShow.value = true;
//   } else {
//     testShow.value = false;
//   }
//   console.log("testShow", testShow.value);
// }

const timelineList= ref([
    {
        index:'2013',
        content:'公司取得第一个VR房地产应用项目',
      },
      {
        index:'2014',
        content:'作为江西唯一一家VR企业参加中国智慧产业博览会',
      },
      {
        index:'2015',
        content:'公司取得首项VR软件自主知识产权',
      },
      {
        index:'2016',
        content:'公司团队携带众多VR研发成果亮相中国南昌虚拟现实产业基地新闻发布会',
      },
      {
        index:'2017',
        content:'公司研发的平台入选“中国制造2025”省级专项扶持项目/公司多媒体信息化技术为“中国海博会”服务/公司被认证为国家高新技术企业/公司成为省内首家通过知识产权管理体系认证的VR企业/成为南昌市西湖区智慧党建服务中心项目多媒体及自动化控制系统的总承包商',
      },
      {
        index:'2018',
        content:'作为首批VR企业入驻中国（南昌）VR产业基地/成为红谷滩区党群服务中心标杆性项目多媒体及自动化控制系统的总承包商',
      },
      {
        index:'2019',
        content:'公司根据发展战略需要成立南昌世弘泛亚科技股份有限公司/公司入选“中国（南昌）知识产权保护中心”首批保护名单',
      },
      {
        index:'2020',
        content:'公司研发的工业互联网平台入选江西省首批VR应用示范项目/公司顺利通过ISO9001体系和职业健康管理体系认证',
      },
      {
        index:'2021',
        content:'公司所承接打造的“全国青少年井冈山革命传统教育基地党.团史展览及教育中心”被选为“庆祝建党一百周年”江西主会场/公司团队被评为“江西省VR产业优秀创新创业团队”',
      },
      {
        index:'2022',
        content:'公司承接打造的“抚州高新区非公党群服务中心”及“直播电商基地”被评为“两新”党建的品牌项目',
      },
      {
        index:'2023',
        content:'公司的软件团队被评为“江西省软件行业先进单位”/公司所开发的“茅庵岭VR & AR考古互动系统”被评为“江西省VR示范应用项目”',
      },

    ])
</script>
<style  scoped>
.pages_su_one {
  width: 100%;
  height: 100%;
  z-index: 6;
  position: relative;
}
.pages_ab{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
 
}
.pages_title{
  position:absolute;
  top: 4%;
  left: 3%;
  color: #fff;

}
.ab_content{
  position: absolute;
  top: 10%;
  left: 0;
  width: 94%;
  margin: 0 3%;
  height: 86%;
  background-color: #fff;
  border-top-left-radius: 0.6rem;
  border-bottom-right-radius: 0.6rem;
  overflow-y: auto;
}
.content_img{
  width: 92%;
  height: auto;
  margin: 4% 4%;
}
  
/* 时间轴 */
.item {
  margin-left: 0.03rem; /*用左边margin显示时间线*/
  width: calc(100% - 30px); /*因为左边部分用于显示时间线，所以右边部分减去30px*/
  height: auto; /*高度由内容决定*/
  position: relative;
  margin-bottom: 1rem;
  cursor: pointer;
}
.kxy{
    width: 0.4rem;
    height: 0.4rem;
    position: absolute;
    top: 0rem;
    left: -0.24rem;
    border-radius: 100%;
    /* background-color: #004eff; */
    background-color: #fff;
    text-align: center;
    border: 1px solid #5297ff;
    display: flex;
    justify-content: center;
    align-items: center;
}
.yx{
    width: 0.25rem;
    height: 0.25rem;
    border-radius: 100%;
    /* background-color: #fff; */
    background-color: #004eff;

}
.item::before {
  /* content: "";
    width: 0.4rem;
    height: 0.4rem;
    border-radius: 100%;
    background-color: #fff;
    border: 1px solid #5297ff;
    position: absolute;
    left: -0.225rem;
    top: -0.13rem; */
    /* background-color: #009966; */
    /* box-shadow: 0 0 0 50px #fff ; */
}

.item::after {
    content: "";
    width: 0rem;
    height: calc(100% + 0.5rem); /*加上10px是item底部的margin*/
    /* background-color: #91c2fc; */
    border: 1px dashed #91c2fc;
    position: absolute;
    top: 0.4rem;
    left: -0.05rem;
}
.item-index {
    line-height: 0.6rem;
    font-size: 0.6rem;
    font-weight: 800;
    position: relative;
    color: #000;
    padding: 0 0rem 0.4rem 0.4rem;
}
.item-content {
  margin-left: 0.5rem;
  width: 90%;
  height: auto; /*由内容决定*/
  font-size: 0.3rem;
  position: relative;
  white-space: pre-wrap; /*保留空白符序列，但是正常地进行换行*/
  word-wrap: break-word; /*在长单词或 URL 地址内部进行换行*/
  padding: 0.2rem;
  border: 0.5px solid #d8d8d8;
  border-radius: 0.2rem;
}
.item:hover::before {
  transform: scale3d(1.2, 1.2, 1);
  background-color: #569ffb;
}
 
.item:hover::after {
  transform: scale3d(1.1, 1, 1);
  background-color: #569ffb;
}
 
.item:hover .item-index{
  transform: scale3d(1.01, 1.01, 1);
  color: #343434;
}
</style>

